import _ from 'lodash'
import {
  GA_KEY as DASHBOARD_KEY
} from '../Dashboard/OperatingDashboard/BestsellerRanking/BestsellerRanking.ga'
import { BESTSELLER_FILTER_TYPE_MAP } from '../../constants/globalTypes'

export const GA_CLICK_ACTION = {
  TABLE_GROUP: 'TABLE_GROUP',
  TABLE_SORT: 'TABLE_SORT',
  TABLE_LINK_AVAILABLE_QUANTITY: 'TABLE_LINK_AVAILABLE_QUANTITY',
  TABLE_LINK_PRICE: 'TABLE_LINK_PRICE',
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_PAGINATION: 'TABLE_PAGINATION',
  STOCK0: 'STOCK0'
}

const COMMON_GA_KEYS = [
  DASHBOARD_KEY.TABLE_GROUP_DAY1,
  DASHBOARD_KEY.TABLE_GROUP_DAY7,
  DASHBOARD_KEY.TABLE_GROUP_DAY14,
  DASHBOARD_KEY.TABLE_GROUP_DAY30,
  DASHBOARD_KEY.TABLE_SORT_AMOUNT,
  DASHBOARD_KEY.TABLE_SORT_QUANTITY,
  DASHBOARD_KEY.TABLE_SORT_PAGEVIEW,
  DASHBOARD_KEY.TABLE_SORT_CONVERSION_RATE,
  DASHBOARD_KEY.TABLE_LINK_AVAILABLE_QUANTITY,
  DASHBOARD_KEY.TABLE_LINK_PRICE
]

const GA_KEY = {
  ..._.pick(DASHBOARD_KEY, COMMON_GA_KEYS),
  EXPORT_EXCEL: 'EXPORT_EXCEL',
  TABLE_PAGINATION: 'TABLE_PAGINATION',
  STOCK0: 'STOCK0'
}

const GA_KEY_MAP = {
  [GA_KEY.TABLE_GROUP_DAY1]: 'topsell_list_day1',
  [GA_KEY.TABLE_GROUP_DAY7]: 'topsell_list_day7',
  [GA_KEY.TABLE_GROUP_DAY14]: 'topsell_list_day14',
  [GA_KEY.TABLE_GROUP_DAY30]: 'topsell_list_day30',
  [GA_KEY.TABLE_SORT_AMOUNT]: 'topsell_list_orderamt',
  [GA_KEY.TABLE_SORT_QUANTITY]: 'topsell_list_ordercnt',
  [GA_KEY.TABLE_SORT_PAGEVIEW]: 'topsell_list_orderpv',
  [GA_KEY.TABLE_SORT_CONVERSION_RATE]: 'topsell_list_ordercvr',
  [GA_KEY.TABLE_LINK_AVAILABLE_QUANTITY]: 'topsell_list_availcnt',
  [GA_KEY.TABLE_LINK_PRICE]: 'topsell_list_currentprice',
  [GA_KEY.EXPORT_EXCEL]: 'topsell_list_downloadfile',
  [GA_KEY.TABLE_PAGINATION]: 'topsell_list_pages',
  [GA_KEY.STOCK0]: 'topsell_list_stock0'
}

export const getI13nModel = (action = {}, customizeI13nModel = {}) => {
  const { type, payload } = action
  let key
  switch (type) {
    case GA_CLICK_ACTION.TABLE_GROUP: {
      const map = {
        1: GA_KEY.TABLE_GROUP_DAY1,
        7: GA_KEY.TABLE_GROUP_DAY7,
        14: GA_KEY.TABLE_GROUP_DAY14,
        30: GA_KEY.TABLE_GROUP_DAY30
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_SORT: {
      const map = {
        [BESTSELLER_FILTER_TYPE_MAP.AMOUNT.type]: GA_KEY.TABLE_SORT_AMOUNT,
        [BESTSELLER_FILTER_TYPE_MAP.QUANTITY.type]: GA_KEY.TABLE_SORT_QUANTITY,
        [BESTSELLER_FILTER_TYPE_MAP.PAGE_VIEW.type]: GA_KEY.TABLE_SORT_PAGEVIEW,
        [BESTSELLER_FILTER_TYPE_MAP.CONVERSION_RATE.type]: GA_KEY.TABLE_SORT_CONVERSION_RATE
      }
      key = map[payload]
      break
    }
    case GA_CLICK_ACTION.TABLE_LINK_AVAILABLE_QUANTITY:
    case GA_CLICK_ACTION.TABLE_LINK_PRICE:
    case GA_CLICK_ACTION.EXPORT_EXCEL:
    case GA_CLICK_ACTION.TABLE_PAGINATION:
    case GA_CLICK_ACTION.STOCK0:
      key = GA_KEY[type]
      break
    default:
      break
  }
  const i13nModel = {
    category: 'topselling',
    action: 'topsellinglist',
    label: GA_KEY_MAP[key],
    ...customizeI13nModel
  }
  return i13nModel
}
